import { createContext } from "react";

export const ParamsContext = createContext();
